module.exports = __webpack_public_path__ + "media/images/carat-7ad214f17c40af426c0f7fd6892a2cf4.svg";